import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {AgentModel} from "../../../agents/angular/models/agent.model";

export class bringozLocationSettingsFormCtrl implements IController {

  locationSettings: any;
  enforceLocations?: boolean;
  hideActivation: boolean;
  showEnforceLocations?: boolean;
  isActive: boolean;
  depots: any;
  branchIds: any;
  agent: AgentModel;
  disableDepots?: boolean;
  isDisabled: boolean;
  onEnforceLocationsChange: Function;
  onChange: Function;

  private locationTypes: any;

  constructor(private planningConstants) {
  }

  $onInit() {
    if (_.isUndefined(this.isActive)) {
      this.isActive = !!this.locationSettings;
    }
    this.locationTypes = this.planningConstants.locationTypes;
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.branchIds && !changes.branchIds.isFirstChange()) {
      if (!this.locationSettings) {
        this.locationSettings = {};
      }
      this.locationSettings.destinationId = undefined;
    }
  }

  onToggleActivation() {
    let locationSettings = this.isActive ? {
      departurePointType: 'UNDEFINED',
      destinationPointType: 'UNDEFINED'
    } : undefined;
    this._locationChange(locationSettings);
  }

  onDeparturePointTypeChange() {
    this.locationSettings.departurePoint = undefined;
    this.locationSettings.departureId = undefined;
    this._locationChange(this.locationSettings);
  }

  onDestinationPointTypeChange() {
    this.locationSettings.destinationPoint = undefined;
    this.locationSettings.destinationId = undefined;
    this._locationChange(this.locationSettings);
  }

  onAddressSelect(allocationAddressRef, address) {
    this.locationSettings[allocationAddressRef] = address;
    this._locationChange(this.locationSettings);
  }

  onFetchAddress(allocationAddressRef) {
    if(this.agent && this.agent.address){
      this.locationSettings[allocationAddressRef] = this.agent.address;
    }
  }

  onDepotSelect(allocationDepotRef, locationPointRef, depot) {
    const selectedDepot = this.depots ? _.find(this.depots, (d) => {
      return _.isEqual(d.id, _.get(depot, 'id'));
    }) : depot;

    this.locationSettings[allocationDepotRef] = _.get(selectedDepot, 'id');
    this.locationSettings[locationPointRef] = _.get(selectedDepot, 'address');
    this._locationChange(this.locationSettings);
  }

  private _locationChange(locationSettings) {
    this.onChange({locationSettings: locationSettings});
  }

}


angular
  .module('bringoz.admin.commons')
  .component('bringozLocationSettingsForm', {
    require: {
      form: '^form'
    },
    bindings: {
      locationSettings: '<',
      enforceLocations: '<?',
      hideActivation: '<?',
      showEnforceLocations: '<?',
      isActive: '<?',
      depots: '<?',
      branchIds: '<?',
      agent: '<?',
      disableDepots: '<?',
      isDisabled: '<?',
      onEnforceLocationsChange: '&',
      onChange: '&'
    },
    template: require('./bringoz-location-settings-form.html').default,
    controller: bringozLocationSettingsFormCtrl
  });
